// extracted by mini-css-extract-plugin
module.exports = {"primary_color":"#1849b4","secondary_color":"#3263CE","ribbon_strip_slim_saturation_color":"#1849b4"};